var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5925 2.02719C12.6803 1.04234 11.4063 0.5 10 0.5C8.58627 0.5 7.30799 1.03906 6.40002 2.01781C5.48221 3.00734 5.03502 4.35219 5.14002 5.80437C5.34815 8.66937 7.52831 11 10 11C12.4717 11 14.6481 8.66984 14.8596 5.80531C14.966 4.36625 14.516 3.02422 13.5925 2.02719ZM18.25 21.5H1.75002C1.53405 21.5028 1.32017 21.4574 1.12394 21.3672C0.927715 21.2769 0.754072 21.1441 0.615649 20.9783C0.310961 20.6141 0.188149 20.1167 0.279086 19.6137C0.674711 17.4191 1.9094 15.5755 3.85002 14.2812C5.57409 13.1323 7.75799 12.5 10 12.5C12.2421 12.5 14.426 13.1328 16.15 14.2812C18.0906 15.575 19.3253 17.4186 19.721 19.6133C19.8119 20.1162 19.6891 20.6136 19.3844 20.9778C19.246 21.1437 19.0724 21.2766 18.8762 21.367C18.6799 21.4573 18.466 21.5028 18.25 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserWhite);
export default __webpack_public_path__ + "static/media/icon-user-white.7b58073fb643fb62b9c6d18772eef1d6.svg";
export { ForwardRef as ReactComponent };